import { API } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";

import ToolForm from "components/tools/ToolForm";
import { createTool } from "graphql/mutations";
import { LayoutContext } from "layout/context/LayoutContext";

const ToolCreateForm = ({ onSuccess }) => {
  const { me } = useContext(LayoutContext);
  const navigate = useNavigate();
  const tool = {
    name: "",
    location: "",
    description: "",
    technicianID: "",
    companyID: me.companyID ?? "",
  };

  async function onSubmit(valuesParam) {
    try {
      const { name, location, description, companyID, technicianID } =
        valuesParam;

      await API.graphql({
        query: createTool.replaceAll("__typename", ""),
        variables: {
          input: {
            name,
            location,
            description,
            companyID,
            technicianID: technicianID || null,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/tools");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  return (
    <div>
      <ToolForm onSubmit={onSubmit} initialValues={tool} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Herramienta",
    successAdded: "Herramienta agregada con éxito",
    responses: {},
  },
});

export default ToolCreateForm;
